import { createSlice } from '@reduxjs/toolkit';
import { getFunctionsByRole, getProfile, getTinhs, getAllDms, getKinhTuyenTruc } from '../../services/apis/danhmuc-service';
import { Constant } from '../../constants/constant';

const commonReducer = createSlice({
    name: 'common',
    initialState: {
        functions: {
            data: [],
            loading: 'idle',
        },
        profile: {
            data: {},
            loading: 'idle',
        },
        tinhs: {
            data: [],
            loading: 'idle',
        },
        kinhtuyentruc: {
            data_dp: [],
            data_tw: [],
            loading: 'idle',
        },
        danhmucs: {
            data: [],
            loading: 'idle',
        },
    },
    extraReducers: (builder) => {
        builder
            // Profile
            .addCase(getProfile.pending, (state, action) => {
                state.profile = { data: [], loading: 'pending' };
            })
            .addCase(getProfile.fulfilled, (state, action) => {
                state.profile = { data: action.payload, loading: 'success' };
                // if(!action?.payload) {
                //     localStorage.removeItem('accessToken')
                // }
            })
            .addCase(getProfile.rejected, (state, action) => {
                state.profile = { data: action.error, loading: 'error' };
            })
            //Functions
            // .addCase(getFunctionsByRole.pending, (state, action) => {
            //     state.functions = { data: [], loading: 'pending' };
            // })
            .addCase(getFunctionsByRole.fulfilled, (state, action) => {
                state.functions = { data: action.payload, loading: 'success' };
            })
            .addCase(getFunctionsByRole.rejected, (state, action) => {
                state.functions = { data: action.error, loading: 'error' };
            });
    },
    // extraReducers: {
    //     //Functions
    //     [getFunctionsByRole.pending]: (state, action) => {
    //         state.functions = { data: [], loading: 'pending' };
    //     },
    //     [getFunctionsByRole.fulfilled]: (state, action) => {
    //         state.functions = { data: action.payload, loading: 'success' };
    //     },
    //     [getFunctionsByRole.rejected]: (state, action) => {
    //         state.functions = { data: action.error, loading: 'error' };
    //     },
    //     //profile
    //     [getProfile.pending]: (state, action) => {
    //         state.profile = { data: [], loading: 'pending' };
    //     },
    //     [getProfile.fulfilled]: (state, action) => {
    //         state.profile = { data: action.payload, loading: 'success' };
    //     },
    //     [getProfile.rejected]: (state, action) => {
    //         state.profile = { data: action.error, loading: 'error' };
    //     },
    //     //tinhs
    //     [getTinhs.pending]: (state, action) => {
    //         state.tinhs = { data: [], loading: 'pending' };
    //     },
    //     [getTinhs.fulfilled]: (state, action) => {
    //         state.tinhs = { data: action.payload, loading: 'success' };
    //     },
    //     [getTinhs.rejected]: (state, action) => {
    //         state.tinhs = { data: action.error, loading: 'error' };
    //     },
    //     //all danh muc
    //     [getAllDms.pending]: (state, action) => {
    //         state.danhmucs = { data: [], loading: 'pending' };
    //     },
    //     [getAllDms.fulfilled]: (state, action) => {
    //         state.danhmucs = { data: action.payload, loading: 'success' };
    //     },
    //     [getAllDms.rejected]: (state, action) => {
    //         state.danhmucs = { data: action.error, loading: 'error' };
    //     },
    //     //kinhtuyentruc
    //     [getKinhTuyenTruc.pending]: (state, action) => {
    //         state.kinhtuyentruc = { ...state.kinhtuyentruc, loading: 'pending' };
    //     },
    //     [getKinhTuyenTruc.fulfilled]: (state, action) => {
    //         if (action.payload.cap === Constant.CAP_TQ.DIAPHUONG) {
    //             state.kinhtuyentruc = { ...state.kinhtuyentruc, data_dp: action.payload.data, loading: 'success' };
    //         } else {
    //             state.kinhtuyentruc = { ...state.kinhtuyentruc, data_tw: action.payload.data, loading: 'success' };
    //         }
    //     },
    //     [getKinhTuyenTruc.rejected]: (state, action) => {
    //         state.kinhtuyentruc = { ...state.kinhtuyentruc, loading: 'error' };
    //     },
    // },
});

export default commonReducer;
